/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import UseSpecType from './UseSpecType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/UseSpecType (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="version" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="container" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;sequence&gt; &lt;element name="use" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;sequence&gt; &lt;element name="useSpec" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="type" type="{}useSpecType" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="searchPath" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="imports" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="ancestors" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="property" type="{}propertyType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;element name="expressionLocale" type="{http://www.w3.org/2001/XMLSchema}language" minOccurs="0"/&gt; &lt;element name="fmModel" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;choice&gt; &lt;element ref="{}dataSource" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}querySubject" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}filter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}calculation" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}parameterMap" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="metadataTreeView" type="{}folderType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="metadataTreeViewFocus" type="{}focus" minOccurs="0"/&gt; &lt;element name="textResource" type="{}textResource" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}drillGroup" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}namedSet" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}parameterValueSet" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}prompt" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/choice&gt; &lt;element name="dataRetrievalMode" minOccurs="0"&gt; &lt;simpleType&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="liveConnection"/&gt; &lt;enumeration value="snapShot"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; &lt;/element&gt; &lt;element name="refActiveParameterValueSet" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class Module extends ObjectType{

	//_flattenedObjectTypeList = null;



	version = null;

	container = null;

	use = null;

	useSpec = null;

	expressionLocale = null;

	fmModel = null;

	dataSource = null;

	querySubject = null;

	filter = null;

	calculation = null;

	relationship = null;

	parameterMap = null;

	metadataTreeView = null;

	metadataTreeViewFocus = null;

	textResource = null;

	drillGroup = null;

	namedSet = null;

	parameterValueSet = null;

	prompt = null;

	dataRetrievalMode = null;

	refActiveParameterValueSet = null;

	_overrideMode = false;

	_originalVersion = 0.0;



	/**
	 * Gets the value of the version property.
	 * @return {String} possible object is {@link String}
	 */
	getVersion() {
		return this.version;
	}

	/**
	 * Sets the value of the version property.
	 * @param {String} value allowed object is {@link String}
	 */
	setVersion(value) {
		var oldValue = this.version;
		this.version = value;
		this._setAndNotify(139, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the container property.
	 * @return {String} possible object is {@link String}
	 */
	getContainer() {
		return this.container;
	}

	/**
	 * Sets the value of the container property.
	 * @param {String} value allowed object is {@link String}
	 */
	setContainer(value) {
		var oldValue = this.container;
		this.container = value;
		this._setAndNotify(129, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the use property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the use property. <p> For example, to add a new item, do as follows: <pre> getUse().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getUse() {
		if (!this.use) {
			this.use = [];
		}
		return this.use;
	}

	/**
	 * Gets the value of the useSpec property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the useSpec property. <p> For example, to add a new item, do as follows: <pre> getUseSpec().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Module.UseSpec}
	 */
	getUseSpec() {
		if (!this.useSpec) {
			this.useSpec = [];
		}
		return this.useSpec;
	}

	/**
	 * Gets the value of the expressionLocale property.
	 * @return {String} possible object is {@link String}
	 */
	getExpressionLocale() {
		return this.expressionLocale;
	}

	/**
	 * Sets the value of the expressionLocale property.
	 * @param {String} value allowed object is {@link String}
	 */
	setExpressionLocale(value) {
		var oldValue = this.expressionLocale;
		this.expressionLocale = value;
		this._setAndNotify(137, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the fmModel property.
	 * @return {String} possible object is {@link String}
	 */
	getFmModel() {
		return this.fmModel;
	}

	/**
	 * Sets the value of the fmModel property.
	 * @param {String} value allowed object is {@link String}
	 */
	setFmModel(value) {
		var oldValue = this.fmModel;
		this.fmModel = value;
		this._setAndNotify(131, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the dataSource property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the dataSource property. <p> For example, to add a new item, do as follows: <pre> getDataSource().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DataSource}
	 */
	getDataSource() {
		if (!this.dataSource) {
			this.dataSource = [];
		}
		return this.dataSource;
	}

	/**
	 * Gets the value of the querySubject property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the querySubject property. <p> For example, to add a new item, do as follows: <pre> getQuerySubject().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QuerySubject}
	 */
	getQuerySubject() {
		if (!this.querySubject) {
			this.querySubject = [];
		}
		return this.querySubject;
	}

	/**
	 * Gets the value of the filter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the filter property. <p> For example, to add a new item, do as follows: <pre> getFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Filter}
	 */
	getFilter() {
		if (!this.filter) {
			this.filter = [];
		}
		return this.filter;
	}

	/**
	 * Gets the value of the calculation property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the calculation property. <p> For example, to add a new item, do as follows: <pre> getCalculation().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Calculation}
	 */
	getCalculation() {
		if (!this.calculation) {
			this.calculation = [];
		}
		return this.calculation;
	}

	/**
	 * Gets the value of the relationship property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the relationship property. <p> For example, to add a new item, do as follows: <pre> getRelationship().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Relationship}
	 */
	getRelationship() {
		if (!this.relationship) {
			this.relationship = [];
		}
		return this.relationship;
	}

	/**
	 * Gets the value of the parameterMap property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterMap property. <p> For example, to add a new item, do as follows: <pre> getParameterMap().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterMap}
	 */
	getParameterMap() {
		if (!this.parameterMap) {
			this.parameterMap = [];
		}
		return this.parameterMap;
	}

	/**
	 * Gets the value of the metadataTreeView property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the metadataTreeView property. <p> For example, to add a new item, do as follows: <pre> getMetadataTreeView().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link FolderType}
	 */
	getMetadataTreeView() {
		if (!this.metadataTreeView) {
			this.metadataTreeView = [];
		}
		return this.metadataTreeView;
	}

	/**
	 * Gets the value of the metadataTreeViewFocus property.
	 * @return {Focus} possible object is {@link Focus}
	 */
	getMetadataTreeViewFocus() {
		return this.metadataTreeViewFocus;
	}

	/**
	 * Sets the value of the metadataTreeViewFocus property.
	 * @param {Focus} value allowed object is {@link Focus}
	 */
	setMetadataTreeViewFocus(value) {
		var oldValue = this.metadataTreeViewFocus;
		this.metadataTreeViewFocus = value;
		this._setAndNotify(135, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the textResource property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the textResource property. <p> For example, to add a new item, do as follows: <pre> getTextResource().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TextResource}
	 */
	getTextResource() {
		if (!this.textResource) {
			this.textResource = [];
		}
		return this.textResource;
	}

	/**
	 * drill Information.Gets the value of the drillGroup property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the drillGroup property. <p> For example, to add a new item, do as follows: <pre> getDrillGroup().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DrillGroup}
	 */
	getDrillGroup() {
		if (!this.drillGroup) {
			this.drillGroup = [];
		}
		return this.drillGroup;
	}

	/**
	 * Gets the value of the namedSet property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the namedSet property. <p> For example, to add a new item, do as follows: <pre> getNamedSet().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link NamedSet}
	 */
	getNamedSet() {
		if (!this.namedSet) {
			this.namedSet = [];
		}
		return this.namedSet;
	}

	/**
	 * Gets the value of the parameterValueSet property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterValueSet property. <p> For example, to add a new item, do as follows: <pre> getParameterValueSet().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterValueSet}
	 */
	getParameterValueSet() {
		if (!this.parameterValueSet) {
			this.parameterValueSet = [];
		}
		return this.parameterValueSet;
	}

	/**
	 * Gets the value of the prompt property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the prompt property. <p> For example, to add a new item, do as follows: <pre> getPrompt().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Prompt}
	 */
	getPrompt() {
		if (!this.prompt) {
			this.prompt = [];
		}
		return this.prompt;
	}

	/**
	 * Gets the value of the dataRetrievalMode property.
	 * @return {String} possible object is {@link String}
	 */
	getDataRetrievalMode() {
		return this.dataRetrievalMode;
	}

	/**
	 * Sets the value of the dataRetrievalMode property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDataRetrievalMode(value) {
		var oldValue = this.dataRetrievalMode;
		this.dataRetrievalMode = value;
		this._setAndNotify(141, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the refActiveParameterValueSet property.
	 * @return {String} possible object is {@link String}
	 */
	getRefActiveParameterValueSet() {
		return this.refActiveParameterValueSet;
	}

	/**
	 * Sets the value of the refActiveParameterValueSet property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRefActiveParameterValueSet(value) {
		var oldValue = this.refActiveParameterValueSet;
		this.refActiveParameterValueSet = value;
		this._setAndNotify(136, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the <code>use</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetUse() {
		return this.use;
	}

	/**
	 * Gets the value of the <code>useSpec</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>UseSpec</code> elements, or <code>null</code> if not set
	 */
	basicGetUseSpec() {
		return this.useSpec;
	}

	/**
	 * Gets the value of the <code>dataSource</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>DataSource</code> elements, or <code>null</code> if not set
	 */
	basicGetDataSource() {
		return this.dataSource;
	}

	/**
	 * Gets the value of the <code>querySubject</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>QuerySubject</code> elements, or <code>null</code> if not set
	 */
	basicGetQuerySubject() {
		return this.querySubject;
	}

	/**
	 * Gets the value of the <code>filter</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Filter</code> elements, or <code>null</code> if not set
	 */
	basicGetFilter() {
		return this.filter;
	}

	/**
	 * Gets the value of the <code>calculation</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Calculation</code> elements, or <code>null</code> if not set
	 */
	basicGetCalculation() {
		return this.calculation;
	}

	/**
	 * Gets the value of the <code>relationship</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Relationship</code> elements, or <code>null</code> if not set
	 */
	basicGetRelationship() {
		return this.relationship;
	}

	/**
	 * Gets the value of the <code>parameterMap</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ParameterMap</code> elements, or <code>null</code> if not set
	 */
	basicGetParameterMap() {
		return this.parameterMap;
	}

	/**
	 * Gets the value of the <code>metadataTreeView</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>FolderType</code> elements, or <code>null</code> if not set
	 */
	basicGetMetadataTreeView() {
		return this.metadataTreeView;
	}

	/**
	 * Gets the value of the <code>textResource</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>TextResource</code> elements, or <code>null</code> if not set
	 */
	basicGetTextResource() {
		return this.textResource;
	}

	/**
	 * Gets the value of the <code>drillGroup</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>DrillGroup</code> elements, or <code>null</code> if not set
	 */
	basicGetDrillGroup() {
		return this.drillGroup;
	}

	/**
	 * Gets the value of the <code>namedSet</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>NamedSet</code> elements, or <code>null</code> if not set
	 */
	basicGetNamedSet() {
		return this.namedSet;
	}

	/**
	 * Gets the value of the <code>parameterValueSet</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ParameterValueSet</code> elements, or <code>null</code> if not set
	 */
	basicGetParameterValueSet() {
		return this.parameterValueSet;
	}

	/**
	 * Gets the value of the <code>prompt</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Prompt</code> elements, or <code>null</code> if not set
	 */
	basicGetPrompt() {
		return this.prompt;
	}

	/**
	 * True if the module is in override mode
	 */
	isOverrideMode() {
		return this._overrideMode;
	}

	/**
	 * Set the override mode
	 * @param {boolean} override true to be in override mode
	 */
	setOverrideMode(override) {
		this._overrideMode = override;
	}

	/**
	 * Return a list of flatened ObjectType objects including QuerySubject, Filters, and Calculations
	 * @return {Array} Return a list of flatened ObjectType
	 */
	getFlattenedBaseObjectTypeList() {
		return this._flattenedObjectTypeList;
	}

	/**
	 * Set the faltened ObjectType list
	 * @param {Array} objectTypeList a list of flatened ObjectType
	 */
	setFlattenedBaseObjectTypeList(objectTypeList) {
		this._flattenedObjectTypeList = objectTypeList;
	}

	/**
	 * get original version
	 */
	getOriginalVersion() {
		return this._originalVersion;
	}

	/**
	 * Set the original version
	 * @param {float} orgVersion original version
	 */
	setOriginalVersion(orgVersion) {
		this._originalVersion = orgVersion;
	}

	/**
	 * Creates a new instance of <code>Module</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Module</code> object from.
	 * @return {Module} an object of type <code>Module</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createModule();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addUseAt(position, item) {
		this._addAtAndNotify(this.getUse(), position, item, 130, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addUse(item) {
		this.addUseAt(this.getUse().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeUseAt(position) {
		this._removeAtAndNotify(this.getUse(), position, 130, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeUse(item) {
		var i = this.getUse().indexOf(item);
		if (i >= 0) {
			this.removeUseAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addUseSpecAt(position, item) {
		this._addAtAndNotify(this.getUseSpec(), position, item, 132, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addUseSpec(item) {
		this.addUseSpecAt(this.getUseSpec().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeUseSpecAt(position) {
		this._removeAtAndNotify(this.getUseSpec(), position, 132, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeUseSpec(item) {
		var i = this.getUseSpec().indexOf(item);
		if (i >= 0) {
			this.removeUseSpecAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addDataSourceAt(position, item) {
		this._addAtAndNotify(this.getDataSource(), position, item, 144, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addDataSource(item) {
		this.addDataSourceAt(this.getDataSource().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeDataSourceAt(position) {
		this._removeAtAndNotify(this.getDataSource(), position, 144, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeDataSource(item) {
		var i = this.getDataSource().indexOf(item);
		if (i >= 0) {
			this.removeDataSourceAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addQuerySubjectAt(position, item) {
		this._addAtAndNotify(this.getQuerySubject(), position, item, 143, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addQuerySubject(item) {
		this.addQuerySubjectAt(this.getQuerySubject().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeQuerySubjectAt(position) {
		this._removeAtAndNotify(this.getQuerySubject(), position, 143, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeQuerySubject(item) {
		var i = this.getQuerySubject().indexOf(item);
		if (i >= 0) {
			this.removeQuerySubjectAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addFilterAt(position, item) {
		this._addAtAndNotify(this.getFilter(), position, item, 24, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addFilter(item) {
		this.addFilterAt(this.getFilter().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeFilterAt(position) {
		this._removeAtAndNotify(this.getFilter(), position, 24, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeFilter(item) {
		var i = this.getFilter().indexOf(item);
		if (i >= 0) {
			this.removeFilterAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addCalculationAt(position, item) {
		this._addAtAndNotify(this.getCalculation(), position, item, 25, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addCalculation(item) {
		this.addCalculationAt(this.getCalculation().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeCalculationAt(position) {
		this._removeAtAndNotify(this.getCalculation(), position, 25, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeCalculation(item) {
		var i = this.getCalculation().indexOf(item);
		if (i >= 0) {
			this.removeCalculationAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addRelationshipAt(position, item) {
		this._addAtAndNotify(this.getRelationship(), position, item, 133, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addRelationship(item) {
		this.addRelationshipAt(this.getRelationship().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeRelationshipAt(position) {
		this._removeAtAndNotify(this.getRelationship(), position, 133, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeRelationship(item) {
		var i = this.getRelationship().indexOf(item);
		if (i >= 0) {
			this.removeRelationshipAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addParameterMapAt(position, item) {
		this._addAtAndNotify(this.getParameterMap(), position, item, 134, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addParameterMap(item) {
		this.addParameterMapAt(this.getParameterMap().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeParameterMapAt(position) {
		this._removeAtAndNotify(this.getParameterMap(), position, 134, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeParameterMap(item) {
		var i = this.getParameterMap().indexOf(item);
		if (i >= 0) {
			this.removeParameterMapAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addMetadataTreeViewAt(position, item) {
		this._addAtAndNotify(this.getMetadataTreeView(), position, item, 146, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addMetadataTreeView(item) {
		this.addMetadataTreeViewAt(this.getMetadataTreeView().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeMetadataTreeViewAt(position) {
		this._removeAtAndNotify(this.getMetadataTreeView(), position, 146, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeMetadataTreeView(item) {
		var i = this.getMetadataTreeView().indexOf(item);
		if (i >= 0) {
			this.removeMetadataTreeViewAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addTextResourceAt(position, item) {
		this._addAtAndNotify(this.getTextResource(), position, item, 142, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addTextResource(item) {
		this.addTextResourceAt(this.getTextResource().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeTextResourceAt(position) {
		this._removeAtAndNotify(this.getTextResource(), position, 142, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeTextResource(item) {
		var i = this.getTextResource().indexOf(item);
		if (i >= 0) {
			this.removeTextResourceAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addDrillGroupAt(position, item) {
		this._addAtAndNotify(this.getDrillGroup(), position, item, 138, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addDrillGroup(item) {
		this.addDrillGroupAt(this.getDrillGroup().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeDrillGroupAt(position) {
		this._removeAtAndNotify(this.getDrillGroup(), position, 138, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeDrillGroup(item) {
		var i = this.getDrillGroup().indexOf(item);
		if (i >= 0) {
			this.removeDrillGroupAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addNamedSetAt(position, item) {
		this._addAtAndNotify(this.getNamedSet(), position, item, 26, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addNamedSet(item) {
		this.addNamedSetAt(this.getNamedSet().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeNamedSetAt(position) {
		this._removeAtAndNotify(this.getNamedSet(), position, 26, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeNamedSet(item) {
		var i = this.getNamedSet().indexOf(item);
		if (i >= 0) {
			this.removeNamedSetAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addParameterValueSetAt(position, item) {
		this._addAtAndNotify(this.getParameterValueSet(), position, item, 140, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addParameterValueSet(item) {
		this.addParameterValueSetAt(this.getParameterValueSet().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeParameterValueSetAt(position) {
		this._removeAtAndNotify(this.getParameterValueSet(), position, 140, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeParameterValueSet(item) {
		var i = this.getParameterValueSet().indexOf(item);
		if (i >= 0) {
			this.removeParameterValueSetAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPromptAt(position, item) {
		this._addAtAndNotify(this.getPrompt(), position, item, 145, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addPrompt(item) {
		this.addPromptAt(this.getPrompt().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePromptAt(position) {
		this._removeAtAndNotify(this.getPrompt(), position, 145, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removePrompt(item) {
		var i = this.getPrompt().indexOf(item);
		if (i >= 0) {
			this.removePromptAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Module";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 139, "version", null));
		featureList.push(this.createFeature(false, false, false, 129, "container", null));
		featureList.push(this.createFeature(true, false, false, 130, "use", null));
		var clazz;
		if (factory) {
			clazz = factory.createModuleUseSpec().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 132, "useSpec", clazz));
		featureList.push(this.createFeature(false, false, false, 137, "expressionLocale", null));
		featureList.push(this.createFeature(false, false, false, 131, "fmModel", null));
		if (factory) {
			clazz = factory.createDataSource().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 144, "dataSource", clazz));
		if (factory) {
			clazz = factory.createQuerySubject().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 143, "querySubject", clazz));
		if (factory) {
			clazz = factory.createFilter().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 24, "filter", clazz));
		if (factory) {
			clazz = factory.createCalculation().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 25, "calculation", clazz));
		if (factory) {
			clazz = factory.createRelationship().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 133, "relationship", clazz));
		if (factory) {
			clazz = factory.createParameterMap().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 134, "parameterMap", clazz));
		if (factory) {
			clazz = factory.createFolderType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 146, "metadataTreeView", clazz));
		if (factory) {
			clazz = factory.createFocus().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 135, "metadataTreeViewFocus", clazz));
		if (factory) {
			clazz = factory.createTextResource().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 142, "textResource", clazz));
		if (factory) {
			clazz = factory.createDrillGroup().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 138, "drillGroup", clazz));
		if (factory) {
			clazz = factory.createNamedSet().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 26, "namedSet", clazz));
		if (factory) {
			clazz = factory.createParameterValueSet().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 140, "parameterValueSet", clazz));
		if (factory) {
			clazz = factory.createPrompt().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 145, "prompt", clazz));
		featureList.push(this.createFeature(false, false, false, 141, "dataRetrievalMode", null));
		featureList.push(this.createFeature(false, false, false, 136, "refActiveParameterValueSet", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 129:
			this.setContainer((value));
			break;
		case 131:
			this.setFmModel((value));
			break;
		case 135:
			this.setMetadataTreeViewFocus((value));
			break;
		case 136:
			this.setRefActiveParameterValueSet((value));
			break;
		case 137:
			this.setExpressionLocale((value));
			break;
		case 139:
			this.setVersion((value));
			break;
		case 141:
			this.setDataRetrievalMode((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 25:
			this.calculation = (value);
			break;
		case 130:
			this.use = (value);
			break;
		case 132:
			this.useSpec = (value);
			break;
		case 26:
			this.namedSet = (value);
			break;
		case 133:
			this.relationship = (value);
			break;
		case 134:
			this.parameterMap = (value);
			break;
		case 138:
			this.drillGroup = (value);
			break;
		case 140:
			this.parameterValueSet = (value);
			break;
		case 24:
			this.filter = (value);
			break;
		case 142:
			this.textResource = (value);
			break;
		case 143:
			this.querySubject = (value);
			break;
		case 144:
			this.dataSource = (value);
			break;
		case 145:
			this.prompt = (value);
			break;
		case 146:
			this.metadataTreeView = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 129:
			return this.getContainer();
		case 25:
			return this.getCalculation();
		case 130:
			return this.getUse();
		case 131:
			return this.getFmModel();
		case 132:
			return this.getUseSpec();
		case 26:
			return this.getNamedSet();
		case 133:
			return this.getRelationship();
		case 134:
			return this.getParameterMap();
		case 135:
			return this.getMetadataTreeViewFocus();
		case 136:
			return this.getRefActiveParameterValueSet();
		case 137:
			return this.getExpressionLocale();
		case 138:
			return this.getDrillGroup();
		case 139:
			return this.getVersion();
		case 140:
			return this.getParameterValueSet();
		case 24:
			return this.getFilter();
		case 141:
			return this.getDataRetrievalMode();
		case 142:
			return this.getTextResource();
		case 143:
			return this.getQuerySubject();
		case 144:
			return this.getDataSource();
		case 145:
			return this.getPrompt();
		case 146:
			return this.getMetadataTreeView();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 129:
			return this.getContainer();
		case 25:
			return this.basicGetCalculation();
		case 130:
			return this.basicGetUse();
		case 131:
			return this.getFmModel();
		case 132:
			return this.basicGetUseSpec();
		case 26:
			return this.basicGetNamedSet();
		case 133:
			return this.basicGetRelationship();
		case 134:
			return this.basicGetParameterMap();
		case 135:
			return this.getMetadataTreeViewFocus();
		case 136:
			return this.getRefActiveParameterValueSet();
		case 137:
			return this.getExpressionLocale();
		case 138:
			return this.basicGetDrillGroup();
		case 139:
			return this.getVersion();
		case 140:
			return this.basicGetParameterValueSet();
		case 24:
			return this.basicGetFilter();
		case 141:
			return this.getDataRetrievalMode();
		case 142:
			return this.basicGetTextResource();
		case 143:
			return this.basicGetQuerySubject();
		case 144:
			return this.basicGetDataSource();
		case 145:
			return this.basicGetPrompt();
		case 146:
			return this.basicGetMetadataTreeView();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 25:
			this.addCalculationAt(position, (value));
			break;
		case 130:
			this.addUseAt(position, (value));
			break;
		case 132:
			this.addUseSpecAt(position, (value));
			break;
		case 26:
			this.addNamedSetAt(position, (value));
			break;
		case 133:
			this.addRelationshipAt(position, (value));
			break;
		case 134:
			this.addParameterMapAt(position, (value));
			break;
		case 138:
			this.addDrillGroupAt(position, (value));
			break;
		case 140:
			this.addParameterValueSetAt(position, (value));
			break;
		case 24:
			this.addFilterAt(position, (value));
			break;
		case 142:
			this.addTextResourceAt(position, (value));
			break;
		case 143:
			this.addQuerySubjectAt(position, (value));
			break;
		case 144:
			this.addDataSourceAt(position, (value));
			break;
		case 145:
			this.addPromptAt(position, (value));
			break;
		case 146:
			this.addMetadataTreeViewAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 25:
			this.addCalculation((value));
			break;
		case 130:
			this.addUse((value));
			break;
		case 132:
			this.addUseSpec((value));
			break;
		case 26:
			this.addNamedSet((value));
			break;
		case 133:
			this.addRelationship((value));
			break;
		case 134:
			this.addParameterMap((value));
			break;
		case 138:
			this.addDrillGroup((value));
			break;
		case 140:
			this.addParameterValueSet((value));
			break;
		case 24:
			this.addFilter((value));
			break;
		case 142:
			this.addTextResource((value));
			break;
		case 143:
			this.addQuerySubject((value));
			break;
		case 144:
			this.addDataSource((value));
			break;
		case 145:
			this.addPrompt((value));
			break;
		case 146:
			this.addMetadataTreeView((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 25:
			this.removeCalculationAt(position);
			break;
		case 130:
			this.removeUseAt(position);
			break;
		case 132:
			this.removeUseSpecAt(position);
			break;
		case 26:
			this.removeNamedSetAt(position);
			break;
		case 133:
			this.removeRelationshipAt(position);
			break;
		case 134:
			this.removeParameterMapAt(position);
			break;
		case 138:
			this.removeDrillGroupAt(position);
			break;
		case 140:
			this.removeParameterValueSetAt(position);
			break;
		case 24:
			this.removeFilterAt(position);
			break;
		case 142:
			this.removeTextResourceAt(position);
			break;
		case 143:
			this.removeQuerySubjectAt(position);
			break;
		case 144:
			this.removeDataSourceAt(position);
			break;
		case 145:
			this.removePromptAt(position);
			break;
		case 146:
			this.removeMetadataTreeViewAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 25:
			this.removeCalculation((item));
			break;
		case 130:
			this.removeUse((item));
			break;
		case 132:
			this.removeUseSpec((item));
			break;
		case 26:
			this.removeNamedSet((item));
			break;
		case 133:
			this.removeRelationship((item));
			break;
		case 134:
			this.removeParameterMap((item));
			break;
		case 138:
			this.removeDrillGroup((item));
			break;
		case 140:
			this.removeParameterValueSet((item));
			break;
		case 24:
			this.removeFilter((item));
			break;
		case 142:
			this.removeTextResource((item));
			break;
		case 143:
			this.removeQuerySubject((item));
			break;
		case 144:
			this.removeDataSource((item));
			break;
		case 145:
			this.removePrompt((item));
			break;
		case 146:
			this.removeMetadataTreeView((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="identifier" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="type" type="{}useSpecType" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="searchPath" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="imports" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="ancestors" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="property" type="{}propertyType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
Module.UseSpec = class extends MoserObject{

	identifier = null;

	type = null;

	storeID = null;

	searchPath = null;

	imports = null;

	ancestors = null;

	dataCacheExpiry = null;

	property = null;



	/**
	 * Gets the value of the identifier property.
	 * @return {String} possible object is {@link String}
	 */
	getIdentifier() {
		return this.identifier;
	}

	/**
	 * Sets the value of the identifier property.
	 * @param {String} value allowed object is {@link String}
	 */
	setIdentifier(value) {
		var oldValue = this.identifier;
		this.identifier = value;
		this._setAndNotify(38, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the type property.
	 * @return {UseSpecType} possible object is {@link UseSpecType}
	 */
	getType() {
		return this.type;
	}

	/**
	 * Sets the value of the type property.
	 * @param {UseSpecType} value allowed object is {@link UseSpecType}
	 */
	setType(value) {
		var oldValue = this.type;
		this.type = value;
		this._setAndNotify(15, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the storeID property.
	 * @return {String} possible object is {@link String}
	 */
	getStoreID() {
		return this.storeID;
	}

	/**
	 * Sets the value of the storeID property.
	 * @param {String} value allowed object is {@link String}
	 */
	setStoreID(value) {
		var oldValue = this.storeID;
		this.storeID = value;
		this._setAndNotify(88, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the searchPath property.
	 * @return {String} possible object is {@link String}
	 */
	getSearchPath() {
		return this.searchPath;
	}

	/**
	 * Sets the value of the searchPath property.
	 * @param {String} value allowed object is {@link String}
	 */
	setSearchPath(value) {
		var oldValue = this.searchPath;
		this.searchPath = value;
		this._setAndNotify(86, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the imports property.
	 * @return {String} possible object is {@link String}
	 */
	getImports() {
		return this.imports;
	}

	/**
	 * Sets the value of the imports property.
	 * @param {String} value allowed object is {@link String}
	 */
	setImports(value) {
		var oldValue = this.imports;
		this.imports = value;
		this._setAndNotify(85, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the ancestors property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the ancestors property. <p> For example, to add a new item, do as follows: <pre> getAncestors().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Module.UseSpec.Ancestors}
	 */
	getAncestors() {
		if (!this.ancestors) {
			this.ancestors = [];
		}
		return this.ancestors;
	}

	/**
	 * Gets the value of the dataCacheExpiry property.
	 * @return {String} possible object is {@link String}
	 */
	getDataCacheExpiry() {
		return this.dataCacheExpiry;
	}

	/**
	 * Sets the value of the dataCacheExpiry property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDataCacheExpiry(value) {
		var oldValue = this.dataCacheExpiry;
		this.dataCacheExpiry = value;
		this._setAndNotify(62, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the property property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the property property. <p> For example, to add a new item, do as follows: <pre> getProperty().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link PropertyType}
	 */
	getProperty() {
		if (!this.property) {
			this.property = [];
		}
		return this.property;
	}

	/**
	 * Gets the value of the <code>ancestors</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Ancestors</code> elements, or <code>null</code> if not set
	 */
	basicGetAncestors() {
		return this.ancestors;
	}

	/**
	 * Gets the value of the <code>property</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>PropertyType</code> elements, or <code>null</code> if not set
	 */
	basicGetProperty() {
		return this.property;
	}

	/**
	 * Creates a new instance of <code>UseSpec</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> UseSpec</code> object from.
	 * @return {UseSpec} an object of type <code>UseSpec</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createModuleUseSpec();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addAncestorsAt(position, item) {
		this._addAtAndNotify(this.getAncestors(), position, item, 89, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addAncestors(item) {
		this.addAncestorsAt(this.getAncestors().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeAncestorsAt(position) {
		this._removeAtAndNotify(this.getAncestors(), position, 89, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeAncestors(item) {
		var i = this.getAncestors().indexOf(item);
		if (i >= 0) {
			this.removeAncestorsAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addPropertyAt(position, item) {
		this._addAtAndNotify(this.getProperty(), position, item, 87, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addProperty(item) {
		this.addPropertyAt(this.getProperty().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removePropertyAt(position) {
		this._removeAtAndNotify(this.getProperty(), position, 87, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeProperty(item) {
		var i = this.getProperty().indexOf(item);
		if (i >= 0) {
			this.removePropertyAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "UseSpec";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 38, "identifier", null));
		featureList.push(this.createFeature(false, true, false, 15, "type", UseSpecType));
		featureList.push(this.createFeature(false, false, false, 88, "storeID", null));
		featureList.push(this.createFeature(false, false, false, 86, "searchPath", null));
		featureList.push(this.createFeature(false, false, false, 85, "imports", null));
		var clazz;
		if (factory) {
			clazz = factory.createModuleUseSpecAncestors().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 89, "ancestors", clazz));
		featureList.push(this.createFeature(false, false, false, 62, "dataCacheExpiry", null));
		if (factory) {
			clazz = factory.createPropertyType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 87, "property", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 38:
			this.setIdentifier((value));
			break;
		case 85:
			this.setImports((value));
			break;
		case 86:
			this.setSearchPath((value));
			break;
		case 62:
			this.setDataCacheExpiry((value));
			break;
		case 15:
			this.setType((value));
			break;
		case 88:
			this.setStoreID((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 87:
			this.property = (value);
			break;
		case 89:
			this.ancestors = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 38:
			return this.getIdentifier();
		case 85:
			return this.getImports();
		case 86:
			return this.getSearchPath();
		case 87:
			return this.getProperty();
		case 62:
			return this.getDataCacheExpiry();
		case 15:
			return this.getType();
		case 88:
			return this.getStoreID();
		case 89:
			return this.getAncestors();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 38:
			return this.getIdentifier();
		case 85:
			return this.getImports();
		case 86:
			return this.getSearchPath();
		case 87:
			return this.basicGetProperty();
		case 62:
			return this.getDataCacheExpiry();
		case 15:
			return this.getType();
		case 88:
			return this.getStoreID();
		case 89:
			return this.basicGetAncestors();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 87:
			this.addPropertyAt(position, (value));
			break;
		case 89:
			this.addAncestorsAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 87:
			this.addProperty((value));
			break;
		case 89:
			this.addAncestors((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 87:
			this.removePropertyAt(position);
			break;
		case 89:
			this.removeAncestorsAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 87:
			this.removeProperty((item));
			break;
		case 89:
			this.removeAncestors((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="defaultName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="storeID" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
Module.UseSpec.Ancestors = class extends MoserObject{

	defaultName = null;

	storeID = null;



	/**
	 * Gets the value of the defaultName property.
	 * @return {String} possible object is {@link String}
	 */
	getDefaultName() {
		return this.defaultName;
	}

	/**
	 * Sets the value of the defaultName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDefaultName(value) {
		var oldValue = this.defaultName;
		this.defaultName = value;
		this._setAndNotify(220, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the storeID property.
	 * @return {String} possible object is {@link String}
	 */
	getStoreID() {
		return this.storeID;
	}

	/**
	 * Sets the value of the storeID property.
	 * @param {String} value allowed object is {@link String}
	 */
	setStoreID(value) {
		var oldValue = this.storeID;
		this.storeID = value;
		this._setAndNotify(88, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>Ancestors</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> Ancestors</code> object from.
	 * @return {Ancestors} an object of type <code>Ancestors</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createModuleUseSpecAncestors();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "Ancestors";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 220, "defaultName", null));
		featureList.push(this.createFeature(false, false, false, 88, "storeID", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 88:
			this.setStoreID((value));
			break;
		case 220:
			this.setDefaultName((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 88:
			return this.getStoreID();
		case 220:
			return this.getDefaultName();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 88:
			return this.getStoreID();
		case 220:
			return this.getDefaultName();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/Module.js